import type BaseModel from '@/data/models/BaseModel'
import type { NumericBoolean } from '@/core/types'
import type { PaginationUrlFilterType } from '@/services/tables/types'

export type BulkBaseBody = Record<string, unknown>
export type BulkSettingsType = {
  model: typeof BaseModel
}
export type BulkDeleteParams = {
  ids: string[]
  all: boolean
  fromGroupId?: string
  userId?: string
  deleteContacts?: boolean
  filters?: PaginationUrlFilterType
  status?: string
  categoryId?: string
}
export type BulkParams = {
  ids: string[]
  all: NumericBoolean
}

export const BULK_STATUS_IN_PROGRESS = 'in_progress'
export const BULK_STATUS_COMPLETED = 'completed'
export type BULK_STATUS = typeof BULK_STATUS_IN_PROGRESS | typeof BULK_STATUS_COMPLETED

export const bulkSchemaItemOperations = [
  'attach',
  'detach',
  'detachAll',
  'replace',
  'updateValue',
  'clearFieldValue',
] as const
export type BulkSchemaItemOperation = (typeof bulkSchemaItemOperations)[number]
export const isBulkSchemaItemOperation = (value: unknown): value is BulkSchemaItemOperation =>
  typeof value === 'string' && bulkSchemaItemOperations.includes(value as BulkSchemaItemOperation)
export type BulkSchemaItem = {
  operation: Array<BulkSchemaItemOperation>
}

export type BulkFieldSimpleValue<T = unknown> = {
  updateValue?: T
  clearFieldValue?: boolean
}

export type BulkFieldListValue = {
  attach?: (string | number)[]
  detach?: (string | number)[]
  detachAll?: boolean
  replace?: (string | number)[]
}
export type BulkFieldListRequest =
  | {
      attach: (string | number)[]
    }
  | {
      detach: (string | number)[]
    }
  | {
      detachAll: boolean
    }
  | {
      detachAll: boolean
      attach: (string | number)[]
    }
export type TransformBulkFieldListValueToRequest = (data: BulkFieldListValue) => BulkFieldListRequest
export type BulkFieldListBuilder = {
  build: (name?: string) => void
  transformToRequest: TransformBulkFieldListValueToRequest
}
